// extracted by mini-css-extract-plugin
module.exports = {"hamburgerMenu":"styles_hamburgerMenu__fmNRE"};